import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useForm } from "react-hook-form";
import { useContext } from "react";
import axiosProductionInstance from "../../utils/axios-instances";
import AuthContext from "../../contexts/auth-context";
import { useNavigate } from "react-router-dom";
import NavLink from "../../components/links/nav-link";

const defaultTheme = createTheme();

export default function SignIn() {
  const navigate = useNavigate();
  const { auth, setAuth } = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const form = new FormData();
      form.append("email", data.email);
      form.append("password", data.password);
      const response = await axiosProductionInstance({
        method: "post",
        url: `/auth/login`,
        data: form,
      });
      setAuth(response?.data?.data?.user?.token);
      localStorage.setItem("auth", response?.data?.data?.user?.token);
      localStorage.setItem(
        "name",
        response?.data?.data?.user?.firstName +
          " " +
          response?.data?.data?.user?.lastName
      );
      navigate(`/`, { replace: true });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              {...register("email", {
                pattern: {
                  value:
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: "Invalid Email Format",
                },
                required: "Email is required",
              })}
            />
            <Typography color={"error"}>{errors?.email?.message}</Typography>
            <TextField
              margin="normal"
              fullWidth
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              {...register("password", {
                pattern: {
                  value:
                    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                  message:
                    "min length 8 and should have one char, number, and special char",
                },
                required: "Password is required",
              })}
            />
            <Typography color={"error"}>{errors?.password?.message}</Typography>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>

            <Grid container gap={3}>
              <Grid item xs>
                <NavLink
                  path="/"
                  component={
                    <Link href="" variant="body2">
                      Home
                    </Link>
                  }
                />
              </Grid>
              <Grid item>
                <NavLink
                  path="/signUp"
                  component={
                    <Link href="#" variant="body2">
                      {"Don't have an account? Sign Up"}
                    </Link>
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
